import TermsAndConditions from "src/containers/TermsAndConditions";

export default TermsAndConditions;
